import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { IStore } from '../../interfaces/Store'
import StepFileUpload from '../upload/StepFileUpload'
import useUploadHook from '../../hooks/UseUploadHook'
import { IUploadProps } from '../../interfaces/Upload'

const index = 0
function AddressNotChangeHostDocumentUpload(props: IUploadProps): ReactElement {
  const { state, setState, validateFile, isPeriodicRemediation } = props
  const { uploadFile } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
    isPeriodicRemediation,
  })
  const { toggleValidateButton, validationButtonError } = state[index]
  const {
    folder: { top_heb },
  } = useSelector((store: IStore) => store.folderReducer)

  return (
    <div className="col12 mt6md mt3">
      <div className="row">
        <div className="mw77 wFull pr3lg">
          {(top_heb === '0' || top_heb === '1') && isPeriodicRemediation && (
            <div className="row">
              <StepFileUpload
                {...{
                  ...props,
                  title: "Justificatif d'identité de l'hébergeur",
                  fileIndex: 0,
                  index,
                  className: 'col12',
                }}
              />
            </div>
          )}
        </div>
      </div>
      {toggleValidateButton && (
        <div className="row">
          <div className="wFull mw77 dFlex justifyContentEnd flexWrap pr3lg">
            <button
              className="btn btnPrimary btnPrimaryMd wFull wAutoMd"
              type="button"
              onClick={uploadFile}
            >
              Valider les documents
            </button>
            {validationButtonError && (
              <p
                className={`${validationButtonError.type}Error wFull mt1 textRight`}
              >
                {validationButtonError.message}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default AddressNotChangeHostDocumentUpload
